import React from 'react';

import { useTranslation } from 'react-i18next';

import Fade from 'reactstrap/lib/Fade';

import { CatalogFormReply, getProductForm, ProductForm } from '@ttstr/api';
import { LoadingSpinner } from '@ttstr/components';
import QuestionInput from './QuestionInput';

interface OwnProps {
  reply: CatalogFormReply;
}

type Props = Readonly<OwnProps>;

const CatalogForm: React.FC<Props> = ({ reply }) => {
  const { t } = useTranslation();
  const [productForm, setProductForm] = React.useState<ProductForm>(null);
  const abortController = React.useRef<AbortController>();
  const questionIdToAnswerIdMap = React.useMemo(() => {
    return Object.fromEntries(reply.answers.map((answer) => [answer.question_id, answer.id]));
  }, [reply]);

  React.useEffect(() => {
    (async () => {
      abortController.current?.abort();
      abortController.current = new AbortController();
      setProductForm(await getProductForm(reply.form_id, { signal: abortController.current.signal }));
    })();
  }, [reply.form_id]);

  if (!productForm) return <LoadingSpinner className="my-2" label={t('LOADING.DATA')} />;

  return (
    <Fade in>
      <h5>{productForm.title}</h5>
      {Object.entries(productForm.questions_attributes).map(([questionId, question]) => {
        const answerId = questionIdToAnswerIdMap[questionId];

        return (
          <QuestionInput
            key={questionId}
            answerId={answerId}
            question={question}
            defaultValue={reply.answers.find((a) => a.id === Number(answerId))?.value}
          />
        );
      })}
    </Fade>
  );
};

export default React.memo(CatalogForm);
